import { useEffect, useState } from "react";

const SelectableSortableTable = ({
  columns,
  data,
  selectedRows,
  onSelectionChange,
}) => {
  const [tableData, setTableData] = useState(data);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const getBackendId = (row) => row.employeeId || row.shadowEmployeeId;
  const getRowId = (row) => row._tempId;

  useEffect(() => {
    const dataWithIds = data.map((row, index) => ({
      ...row,
      _tempId: index + 1,
    }));
    setTableData(dataWithIds);
  }, [data]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const column = columns.find((col) => col.key === key);
    const sortedData = [...tableData].sort((a, b) => {
      if (column?.compare) {
        return direction === "asc"
          ? column.compare(a, b)
          : column.compare(b, a);
      }

      const valueA = a[key];
      const valueB = b[key];

      if (valueA == null) return direction === "asc" ? -1 : 1;
      if (valueB == null) return direction === "asc" ? 1 : -1;

      if (typeof valueA === "string" && typeof valueB === "string") {
        return direction === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      if (typeof valueA === "number" && typeof valueB === "number") {
        return direction === "asc" ? valueA - valueB : valueB - valueA;
      }

      return direction === "asc"
        ? String(valueA).localeCompare(String(valueB))
        : String(valueB).localeCompare(String(valueA));
    });

    setSortConfig({ key, direction });
    setTableData(sortedData);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      onSelectionChange(tableData.map((row) => getRowId(row))); // use _tempId
    } else {
      onSelectionChange([]);
    }
  };
  return (
    <div className="table-responsive rounded-lg">
      <table className="resume custom">
        <thead>
          <tr>
            <th className="text-center">
              <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={
                  selectedRows.length > 0 &&
                  selectedRows.length === tableData.length
                }
              />
            </th>
            {columns
              .filter((col) => !col.hidden)
              .map((col) => (
                <th
                  key={col.key}
                  onClick={() => col.sortable !== false && handleSort(col.key)}
                  style={{
                    cursor: col.sortable !== false ? "pointer" : "default",
                    textAlign: "center",
                  }}
                >
                  {col.label}{" "}
                  {sortConfig.key === col.key && col.sortable !== false
                    ? sortConfig.direction === "asc"
                      ? "▲"
                      : "▼"
                    : ""}
                </th>
              ))}
          </tr>
        </thead>
        <tbody className="csat--team-members-table">
          {tableData.map((row) => {
            const rowId = getBackendId(row);

            const isSelected = selectedRows.includes(rowId);

            return (
              <tr
                key={row._tempId}
                onClick={() => {
                  const rowId = getRowId(row);
                  const backendId = getBackendId(row);
                  onSelectionChange(
                    selectedRows.includes(rowId)
                      ? selectedRows.filter((r) => r !== rowId)
                      : [...selectedRows, rowId]
                  );
                }}
              >
                <td className="text-center">
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row._tempId)}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => {
                      const rowId = row._tempId;
                      onSelectionChange(
                        selectedRows.includes(rowId)
                          ? selectedRows.filter((r) => r !== rowId)
                          : [...selectedRows, rowId]
                      );
                    }}
                  />
                </td>
                {columns.map((col) => (
                  <td className="text-center" key={col.key}>
                    {col.render(row)}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SelectableSortableTable;
